import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RollTextProps {
    children: ReactNode
    className?: string
}

/* Label that rolls up to a fresh copy of itself when its nearest `group` ancestor is hovered or focused. */
export const RollText: FC<RollTextProps> = ({ children, className }): ReactNode => {
    const motion = 'block transition-transform duration-500 ease-[var(--ease-out-expo)] motion-reduce:transition-none'

    return (
        <span className={cn('relative inline-flex overflow-hidden', className)}>
            <span className={cn(motion, 'group-hover:-translate-y-full group-focus-visible:-translate-y-full')}>
                {children}
            </span>
            <span aria-hidden='true' className={cn(motion, 'absolute inset-0 translate-y-full group-hover:translate-y-0 group-focus-visible:translate-y-0')}>
                {children}
            </span>
        </span>
    )
}
